module.exports = __webpack_public_path__ + "static/media/20200417_123736.70d3f96b.jpg";